import ProtectedArea from './ProtectedArea';
export default ProtectedArea;
